import { render, staticRenderFns } from "./AdsType8.vue?vue&type=template&id=70dd4778&scoped=true&lang=html&"
import script from "./AdsType8.vue?vue&type=script&lang=js&"
export * from "./AdsType8.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./AdsType8.vue?vue&type=style&index=0&id=70dd4778&prod&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "70dd4778",
  null
  ,true
)

export default component.exports